export default __webpack_public_path__ + "static/media/cristinaList.ac0672f9.png";